import { EditorState } from 'prosemirror-state';
import { toggleMark } from 'prosemirror-commands';
import { Fragment, Slice } from 'prosemirror-model';
import { useView } from './use-view';
import schema from '../schema';
import { isLink, useLinkHref } from '../utils';
import { useState } from 'react';
import { Link } from '../components/Link/LinkPrompt';

const NON_EMPTY_HREF_TITLE_FLAG = 'debug';

const toggleLink = toggleMark(schema.marks.link);

// consider later replacing this hook with regular handlers from menu
// keep only modal state
export const useLink = () => {
  const view = useView();

  // const href = useLinkHref(view?.state);

  const insertText = (text, marks) => (state: EditorState, dispatch) => {
    if (state) {
      const node = schema.text(text, marks);
      const frag = Fragment.from(node);
      const slice = new Slice(frag, 0, 0);

      dispatch(
        state?.tr.replaceRange(
          state?.selection.from,
          state?.selection.to,
          slice,
        ),
      );

      return node;
    }
  };

  const insertLink = (link: Link) => (state: EditorState, dispatch) => {
    if (link.title) {
      insertText(link.title, [schema.marks.link.create(link)])(state, dispatch);
    }
  };

  const openLink = (state: EditorState, dispatch) => {
    if (isLink(state)) {
      toggleLink(state, dispatch);
      return;
    }

    setLink({
      title: state.selection.empty ? '' : NON_EMPTY_HREF_TITLE_FLAG,
    });
  };

  // https://github.com/ProseMirror/prosemirror-example-setup/blob/afbc42a68803a57af3f29dd93c3c522c30ea3ed6/src/menu.js#L57-L61
  const [link, setLink] = useState<Link | null>();

  const closeLink = () => setLink(null);

  const updateLink = (state, dispatch, link: Link) => {
    if (link.title !== NON_EMPTY_HREF_TITLE_FLAG) {
      insertLink(link)(state, dispatch);
    } else {
      toggleMark(schema.marks.link, { href: link.href })(state, dispatch);
    }

    setLink(null);
  };

  return {
    link,
    insertLink,
    updateLink,
    openLink,
    closeLink,
  };
};
